// Smart Apartment Data — Urban Nest Quest IDX search.
// Single source of truth: swap this URL if Smart Apartment Data issues a new link.
export const IDX_URL = "https://members.smartapartmentdata.com/web-idx/2db54b72-2ff8-4c16-a16c-f361826b9993";
